const EvenementIntegrated = ({language , token}) => {
    const newEvenementIframe = "https:" +
    window.process.env.URL_EVENT + "/list"
    +  "?lang=" + language + "&token=" +
      token
  
    return (
      <iframe
        id="iframe_evenement_display"
        src={newEvenementIframe}
        allowFullScreen
        frameBorder={"0"}
        style={{ width: '100%', height: '100%', overflow: 'hidden' }}
      />
    );
  };
  
  export default EvenementIntegrated